"use client";

import AddressFormCustomer from "./AddressFormCustomer";
import { bagelFatOne } from "@/utilities/fontImport";
import { cn } from "@/utilities/ui";

export const AddressesDetails = ({ customer }: { customer: any }) => {
  const shippingAddress = customer?.addresses.find(
    (a: any) => a.is_default_shipping,
  );
  const billingAddress = customer?.addresses.find(
    (a: any) => a.is_default_billing,
  );

  return (
    <div>
      <h2 className={cn("text-2xl font-bold mb-1 text-primary", bagelFatOne.className)}>
        Mes adresses
      </h2>
      <p className="font-semibold text-primary/55 text-sm mb-6">
        Vos adresses de livraison et de facturation par défaut.
      </p>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-5">
        <AddressFormCustomer
          type="shipping"
          title="Adresse de livraison"
          address={shippingAddress}
        />
        <AddressFormCustomer
          type="billing"
          title="Adresse de facturation"
          address={billingAddress}
        />
      </div>
    </div>
  );
};
